import React from 'react';
import { Create, number, required, SimpleForm, TextInput } from 'react-admin';
import ManagerAutocompleteInput from '../../../commonComponents/ManagerAutocompleteInput';
import { ACCOUNT_CODE_LENGTH } from '../../../config/constants';
import { numberLengthValidator } from '../../../helpers/validators';

const AccountNumberCreate = (props) => (
  <Create title="Create account number" undoable={false} {...props}>
    <SimpleForm redirect="list">
      <TextInput
        label="Account number"
        source="account_codes"
        validate={[required(), number(), numberLengthValidator(ACCOUNT_CODE_LENGTH[process.env.REACT_APP_APP_TYPE])]}
      />
      <ManagerAutocompleteInput label="BA" source="user_id" validate={required()} />
    </SimpleForm>
  </Create>
);

export default AccountNumberCreate;
